import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavbarComponent } from './navbar/navbar.component';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'pr-page-splash',
  templateUrl: './page-splash.component.html',
  styleUrls: ['./page-splash.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NavbarComponent, MatCardModule],
})
export class PageSplashComponent {}
